// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f2b98c1","732":"744ba19e","977":"f3594ddb"}[chunkId] + ".chunk.js";
};